import { createSelector } from 'reselect';
import { getExperimentalPageData } from 'src/universal/redux/page';
import {
  getOneXpExperiments,
  hasOneXpRequestFinished
} from 'src/universal/redux/oneXp';

export const isG172VariantA = createSelector(
  [getOneXpExperiments, hasOneXpRequestFinished],
  (oneXpExperiments, oneXpDecided) => {
    return (
      oneXpExperiments['GCS-172-VAC-Card-Tile-Revamp']?.dimensions[0]?.variant ===
        'variant-a' && oneXpDecided
    );
  }
);

export const isG172VariantB = createSelector(
  [getOneXpExperiments, hasOneXpRequestFinished],
  (oneXpExperiments, oneXpDecided) => {
    return (
      oneXpExperiments['GCS-172-VAC-Card-Tile-Revamp']?.dimensions[0]?.variant ===
        'variant-b' && oneXpDecided
    );
  }
);

export const isG172Control = createSelector(
  [getOneXpExperiments, hasOneXpRequestFinished],
  (oneXpExperiments, oneXpDecided) => {
    return (
      oneXpExperiments['GCS-172-VAC-Card-Tile-Revamp']?.dimensions[0]?.variant ===
        'control' && oneXpDecided
    );
  }
);

export const isG172Test = createSelector(
  [isG172Control, isG172VariantB, isG172VariantA, hasOneXpRequestFinished],
  (isG172VarControl, G172VarB, isG172VarA, oneXpDecided) => {
    const isTestOn = oneXpDecided && !isG172VarControl && (G172VarB || isG172VarA);
    return isTestOn;
  }
);

export const getG172Data = createSelector(
  [isG172VariantB, getExperimentalPageData],
  (isG172Test, { g172VACRevamp }) => {
    return {
      isG172Test,
      g172StaticData: g172VACRevamp
    };
  }
);
